<template>

  <!-- 1st Hero Variation -->
  <section class="section section-shaped section-lg my-0" style="background-color: black;">

    <div class="container alert alert-warning" v-if="is_load" >
      <div class="row">

        <div class=" col-lg-12 alert alert-danger">
          <h2>Приглашение в проект\задачу</h2>
          <h4 v-if="is_load">{{ name_project}}</h4>

          <button type="danger" class="btn btn-success m-2" v-if="islogin==false" @click="callModalLogin">
            Для продолжения необходимо авторизоваться
          </button>
          <button type="danger" class="btn btn-success m-2" v-if="islogin==true" @click="confirmInvite">
            Принять приглашение
          </button>


        </div>

      </div>
    </div>
  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "../models/Api";
import Modal from "@/components/Modal";
import CircleChart from "@/models/CircleChart";
import vueKanban from 'vue-kanban'
import itemTemplate from '@/components/itemTemplate.vue';
import Editorjsrender from "@/models/Editorjsrender";

export default {
  name: "confirm",

  data() {

    var app = this;

    return {
      "project_id":null,
      "invite_code":null,
      "user":null,
      "is_load":false,
      "islogin":false,
      "name_project":null



    }
  },

  mounted: function () {

    var app = this;
    let id = app.$route.params.id;
    app.project_id=id;
    app.invite_code=app.$route.params.code;


    Api.loadInviteToProject(app.project_id,app.invite_code,function(name_project){
      app.name_project=name_project;
      app.is_load=true;
    })

    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }


    });








  },
  methods: {
    confirmInvite(){
      var app=this;
      var project_id=app.project_id;
      var invite_code=app.invite_code;
      Api.acceptInviteLinkToProject(project_id,invite_code,function(id){
        app.$router.push({name: 'project', params: { "id":id,"rand": Math.random()}});
      })

    },

    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },



  },
  components: {Modal,'editorjsrender': Editorjsrender,}
};
</script>